import React from 'react';
import noop from '../../utils/noop';
import * as styles from './separator.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SeparatorLink = _ref => {
  var label = _ref.label,
    Icon = _ref.icon,
    href = _ref.href,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    className = _ref.className;
  return ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX("a", {
    href: href,
    css: styles.separatorLink,
    onClick: onClick
  }, Icon && ___EmotionJSX(Icon, {
    css: styles.icon
  }), ___EmotionJSX("span", {
    css: styles.linkText
  }, label)));
};
export default SeparatorLink;